export default "__VITE_ASSET__CBuRVfVc__"